// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge--bqQjC","Icon":"Icon--2Ow9L","Count":"Count--3x8pu","Text":"Text--3R8wz"};